import type { User } from '@core/entities/User';
import type { AuthRepository, RegisterPayload } from '@core/repositories/AuthRepository';

export class RegisterUseCase {
  private readonly authRepository: AuthRepository;

  constructor(authRepository: AuthRepository) {
    this.authRepository = authRepository;
  }

  execute(payload: RegisterPayload): Promise<User> {
    return this.authRepository.register(payload);
  }
}
